import { HttpErrorResponse, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { NotificationsService } from '../../shared/services/notifications.service';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private lastErrorTime: number = 0;
  private readonly ERROR_COOLDOWN = 5000; // 5 seconds

  constructor(private notificationsService: NotificationsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          const currentTime = Date.now();
          if (currentTime - this.lastErrorTime > this.ERROR_COOLDOWN) {
            this.notificationsService.showError(
              'An unexpected error occurred. Please try again later.',
            );
            this.lastErrorTime = currentTime;
          }

          // Log the error for debugging purposes
          this.logError(error);
        }
        return throwError(() => error);
      }),
    );
  }
  private logError(error: HttpErrorResponse): void {
    const errorDetails = {
      timestamp: new Date().toISOString(),
      status: error.status,
      statusText: error.statusText,
      url: error.url,
      message: error.message,
    };

    console.error('Server error:', errorDetails);

    // You can add more detailed logging here if needed
    console.group('Detailed Error Information');
    console.log('Error Object:', error);
    console.log('Error JSON:', JSON.stringify(errorDetails, null, 2));
    console.groupEnd();
  }
}
